import React from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import {
  Container,
  Layout,
  Padding,
  Text,
  CollapsableItemList,
  ContainerLineItem,
  ReportLink,
  Chit,
  // Icon,
  // IconList,
  Button,
} from "@kidslivesafe/sc-react";

// import ListModal, {
//   ListModalMode,
// } from "../../../components/UIComponents/ListModal/ListModal";

import {
  selectPreForeclosureSearchStatus,
  selectPropertyReportPreForeclosureData,
  // selectIfReportIsOnList,
  // selectReportLists,
  selectPropertyReport,
} from "../../../features/reports/reportsSlice";
import {
  generateList,
  fullCapsText,
  formatAddress,
  parseDate,
} from "../../../utils";
import LoadingContainerLineItem from "../../../components/UIComponents/LoadingContainerLineItem/LoadingContainerLineItem";
import {
  PullPropertyReportParams,
  usePropertySearchDispatch,
} from "../../../hooks/propertyReportHook";

// import { preForeclosureData } from "../../../features/reports/reportTypes";

import { usePreForeclosureSearchDispatch } from "../../../hooks/preForeclosureHook";

import "./NearbyForeclosure.css";
import { sendMemberEventAsync } from "../../../features/admin/adminSlice";

const NearbyForeclosures: React.FC<{
  containerId: string;
  printReady?: boolean;
}> = ({ containerId, printReady }) => {
  const dispatch = useAppDispatch();
  const pulledReport = useAppSelector(selectPropertyReport);

  const preForeclosureSearchStatus = useAppSelector(
    selectPreForeclosureSearchStatus,
  );
  const nearbyPreforeclosureData = useAppSelector(
    selectPropertyReportPreForeclosureData,
  );
  const pullPropertyReport = usePropertySearchDispatch();
  const searchPreForeclosure = usePreForeclosureSearchDispatch();

  const loading = preForeclosureSearchStatus === "loading";

  const renderChit = ({ text }: { text: string }) => {
    switch (text) {
      case "Pre-foreclosure":
        return <Chit unresponsive chitText={text} dotColor="green" />;
      case "Auction Scheduled":
        return <Chit unresponsive chitText={text} dotColor="yellow" />;
      case "Auction Complete":
        return <Chit unresponsive chitText={text + "d"} dotColor="red" />; // BE reasons
      default:
        return null;
    }
  };
  // ------- START-------
  // all used for list function

  // const [mode, setMode] = useState<ListModalMode>("add-report");
  // const [showListModal, setShowListModal] = useState<boolean>(false);
  // const [reportList, setReportList] = useState<preForeclosureData | undefined>(
  //   undefined,
  // );
  // const [reportId, setReportId] = useState<number | undefined>(undefined);
  // const [list, setList] = useState<any | undefined>(undefined);

  // used to know if certain nearby foreclosure properties are already in lists
  // display star on list entry
  // const reportLists = useAppSelector(selectReportLists);
  // const listsMap = React.useMemo(() => {
  //   if (!nearbyPreforeclosureData || nearbyPreforeclosureData.length === 0)
  //     return {} as Record<
  //       string,
  //       { foundFlag: boolean; list: any; reportId: number | undefined }
  //     >;

  //   const map: Record<
  //     string,
  //     { foundFlag: boolean; list: any; reportId: number | undefined }
  //   > = {};

  //   for (const item of nearbyPreforeclosureData) {
  //     if (!item.propertyId) continue;
  //     // call the pure helper using the current reportLists
  //     const { foundFlag, list, reportId } = selectIfReportIsOnList(
  //       { reports: { reportLists } } as RootState,
  //       item,
  //     );
  //     map[item.propertyId] = { foundFlag, list, reportId };
  //   }
  //   // reset report being saved to list
  //   setTimeout(() => {
  //     setReportList(undefined);
  //   }, 2000);
  //   return map;
  // }, [nearbyPreforeclosureData, reportLists]);

  // useEffect(() => {
  //   if (reportList && listsMap[reportList?.propertyId].foundFlag) {
  //     setList(listsMap[reportList?.propertyId].list);
  //     setReportId(listsMap[reportList?.propertyId].reportId);
  //     setMode("remove-report");
  //   } else {
  //     setList(undefined);
  //     setReportId(undefined);
  //     setMode("add-report");
  //   }
  // }, [reportList]);

  // const handleFavorite = (property: preForeclosureData) => {
  //   setReportList(property);
  //   setShowListModal(true);
  // };

  // ------- End-------

  return (
    <Padding
      left="md"
      right="md"
      breakpointStyles={{
        desktop: {
          space: "none",
        },
      }}
    >
      <Layout type="flex" flexProps={{ direction: "column", gap: "md" }}>
        <Container
          containerTitle={`Nearby Pre-foreclosures ${loading || nearbyPreforeclosureData?.length === 0 ? "" : `(${nearbyPreforeclosureData?.length})`}`}
          containerId={containerId}
          tooltipContent="This section shows up to 20 properties within five miles that are in pre-foreclosure, scheduled for auction, or recently auctioned. Click Search Local Market to see more."
        >
          {loading ? (
            <LoadingContainerLineItem
              lineItemHeader
              lineItemSubHeader
              numberToLoad={5}
            />
          ) : nearbyPreforeclosureData &&
            nearbyPreforeclosureData.length > 0 ? (
            <>
              <CollapsableItemList isOpen={printReady} numberToShow={4}>
                {nearbyPreforeclosureData.map((property, index) => (
                  <div key={property.propertyId}>
                    <Padding top="md" left="md" right="md">
                      <Layout
                        type="flex"
                        flexProps={{
                          direction: "row",
                          alignContent: "space-between",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div className="nearbyForeclosure__chit-container">
                          {renderChit({
                            text: property.propertyPfcType,
                          })}
                        </div>
                        {/* <div
                          onClick={e => {
                            e.preventDefault();
                            handleFavorite(property);
                          }}
                          className="nearbyForeclosure__icon-container"
                        >
                          <Icon
                            size={24}
                            name={
                              listsMap[property.propertyId]?.foundFlag
                                ? IconList.IconStar
                                : IconList.IconStarHollow
                            }
                            iconColor="#F2B415"
                          />
                        </div> */}
                      </Layout>
                    </Padding>
                    <ContainerLineItem
                      lineItemHeaderNoWrap
                      lineItemHeader={
                        <ReportLink<PullPropertyReportParams>
                          noWrap
                          text={fullCapsText(
                            formatAddress(property, "with-comma"),
                          )}
                          inputValue={{
                            addressLine1: property.fullStreetAddress,
                            state: property.state,
                            city: property.city,
                            zip: property.zip5,
                            lat: property.latitude,
                            long: property.longitude,
                            propertyId: property.propertyId,
                            nearbySchoolRadius: 5,
                            searchMethod: "LinkClick",
                          }}
                          handleClick={input => {
                            dispatch(
                              sendMemberEventAsync({
                                EventCategory: "View Foreclosure",
                                EventAction: "Button Click",
                                MetaData: JSON.stringify({
                                  source: "property report",
                                }),
                              }),
                            );

                            pullPropertyReport(input, "property report");
                          }}
                        />
                      }
                      lineItemSubHeader={generateList(
                        [
                          {
                            value: property.recordingDate
                              ? parseDate(property.recordingDate, "MM/DD/YYYY")
                              : "N/A",
                            label: "Recording Date: ",
                          },
                          {
                            value:
                              property.propertyPfcType === "Pre-foreclosure" &&
                              property.lastSoldDate
                                ? parseDate(property.lastSoldDate, "MM/DD/YYYY")
                                : property.auctionDate
                                  ? parseDate(
                                      property.auctionDate,
                                      "MM/DD/YYYY",
                                    )
                                  : "N/A",
                            label:
                              property.propertyPfcType !== "Pre-foreclosure" &&
                              property.auctionDate
                                ? "Auction Date: "
                                : "Last Sold Date: ",
                          },
                        ],
                        " | ",
                      )}
                      lineItemSubHeaderLine2={generateList(
                        [
                          {
                            value: " bds",
                            label: property.bedrooms ? property.bedrooms : null,
                          },
                          {
                            value: " ba",
                            label: property.totalBaths
                              ? property.totalBaths
                              : null,
                          },
                          {
                            value: " sqft",
                            label: property.sumBuildingSqFt
                              ? property.sumBuildingSqFt
                              : null,
                          },
                          {
                            value: " acres",
                            label: property.lotSizeAcres
                              ? property.lotSizeAcres
                              : property.lotSizeAcers //TODO remove when backend is fixed
                                ? property.lotSizeAcers
                                : null,
                          },
                        ],
                        " | ",
                      )}
                      subContent={
                        <Text size="xs">
                          {property.landUseDescription?.toUpperCase() || "N/A"}
                        </Text>
                      }
                      isOpen={printReady ? true : false}
                      key={index}
                    />
                  </div>
                ))}
              </CollapsableItemList>
            </>
          ) : null}
          <Padding left="md" right="md">
            <div className="page-property-report_divider" />
          </Padding>
          <Padding space="md">
            <Layout
              type="flex"
              flexProps={{
                direction: "column",
                gap: "md",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text size="sm" fontWeight="bold">
                Check the local market for distressed homes
              </Text>
              <Button
                size="md"
                fill="fit-content"
                color="primary"
                buttonText="Search Local Market"
                handleClick={() => {
                  if (pulledReport?.propertyDetails) {
                    searchPreForeclosure(
                      pulledReport.propertyDetails,
                      "property report",
                    );
                  }
                }}
              />
            </Layout>
          </Padding>
        </Container>
      </Layout>
      {/* <ListModal
        modalMode={mode}
        setModalMode={setMode}
        displayModal={showListModal}
        setDisplayModal={setShowListModal}
        report={reportList}
        reportId={reportId ? reportId : undefined}
        list={list ? list : undefined}
      /> */}
    </Padding>
  );
};

export default NearbyForeclosures;
